<template>
    <section>
        <transition mode="out-in" name="leftIn">
            <div class="row" v-if="!denuncia">
                <div class="col-12">
                    <label>Informe seu protocolo</label>
                    <div class="input-group mb-3 input-group-sm">
                        <input type="text" class="form-control" placeholder="Protocolo" @keyup.enter="search" v-model="protocolo">
                        
                        <div class="input-group-append">
                            <button class="btn btn-primary" @click="search">Consultar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container-fluit" v-else>
                <div class="row mb-4">
                    <div class="col-12">
                        <h5>Status da denúncia: {{ get_status_name(denuncia.nota_interna.status_id) }}</h5>
                        <h5>Protocolo: {{ denuncia.protocolo }}</h5>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <ul>
                            <li>Para complementar sua denúncia <span class="btn-complementar pointer" @click="formulario = !formulario">clique aqui</span></li>
                            <li v-if="formulario">Arquivos de áudio, vídeo e imagem podem ser anexados no botão anexar.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </transition>

        <complemento v-if="formulario" ref="complemento" :denuncia="denuncia" @success="formulario = false" />
        <hr>

        <div class="d-flex justify-content-end">
            <div v-if="formulario">
                <button @click="$refs.complemento.submit()" class="btn btn-sm btn-light ml-2">Enviar</button>

                <button class="btn btn-sm btn-light ml-2" onclick="$('#files').trigger('click')">
                    <font-awesome-icon icon="paperclip" size="xs" /> Anexar
                </button>

                <button @click="$refs.complemento.clear_form()" class="btn btn-sm btn-light ml-2">Limpar formulário</button>
            </div>

            <router-link :to="{ name: 'den_index' }" class="btn btn-sm btn-light ml-2">Voltar</router-link>
        </div>

        <modal-alert :message="alert_message" />
    </section>
</template>

<script>
import api from '@/mixins/api.js'
import complemento from './Complemento'

export default {
    name: "Consulta",
    mixins: [api],
    components: { complemento },

    data() { 
        return {
            alert_message: "",
            status_den: [],
            type_den: [],
            formulario: false,
            protocolo: null,
            denuncia: null,
        }
},

    created() {
        this.get_status();
        this.get_type_den();
    },

    methods: {
        async get_status() {
            const response = await this.GET("Webform/Status");
            if ( response.status === 'success' ){
                this.status_den = response.result;
            }
        },

        search() {
            if ( this.protocolo ){
                this.get_denuncia();
            }else {
                this.alert_message = 'Preencha o campo protocolo.';
                $("#modal-alert").modal();
            }
        },

        async get_denuncia() {
            const response = await this.GET('Webform', this.protocolo);

            if (response.status === 'success') {

                if (response.result === null) {
                    this.alert_message = "Protocolo não encontrado.";
                    $("#modal-alert").modal();
                }
		this.denuncia = response.result;
                this.denuncia.type = this.get_type_den_name(this.denuncia.type);
            }else {
                this.alert_message = response;
                $("#modal-alert").modal();
            }
        },

        get_status_name(payload) {
            for (var i = 0; i <= this.status_den.length -1; i++) {
                if ( this.status_den[i].id == payload) {
                    return this.status_den[i].nome;
                }
            }
        },

        async get_type_den() {
            const response = await this.GET("Webform/DenType");
            if ( response.status === 'success' ){
                this.type_den = response.result;
            }
        },

        get_type_den_name(payload) {
            for (var i = 0; i < this.type_den.length ; i++) {
                if ( this.type_den[i].id == payload) {
                    return this.type_den[i].nome;
                }
            }
        },
    }
}
</script>

<style>
.btn-complementar {
    color: rgb(62, 153, 115)
}

.btn-complementar:hover {
    color: rgb(53, 121, 93)
}
</style>
